module.exports = __webpack_public_path__ + "static/media/smartband-russian-offer.9228c782.png";